import { BaseResponse } from './base-response.model';
import { UserDropDownJSON } from './user-drop-down.model';
import {
	CallingTreeSuperCoordinatorJSON,
	CallingTreeSuperCoordinator,
} from './calling-tree-super-coordinator.model';
import {
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
	UntypedFormArray,
} from '@angular/forms';

export interface CallingTreeAdminsResponse extends BaseResponse {
	message: string;
	users: UserDropDownJSON[];
	root: number;
	manager: number;
	superCoordinators: CallingTreeSuperCoordinatorJSON[];
}

export class CallingTreeAdmins {
	constructor(
		public rootUserId: number,
		public managerUserId: number,
		public superCoordinators: CallingTreeSuperCoordinator[]
	) {}

	static createFormGroup(admins: CallingTreeAdmins): UntypedFormGroup {
		return new UntypedFormGroup({
			root: new UntypedFormControl(admins.rootUserId, [
				Validators.required,
			]),
			manager: new UntypedFormControl(admins.managerUserId, [
				Validators.required,
			]),
			superCoordinators: CallingTreeSuperCoordinator.createFormArray(
				admins.superCoordinators
			),
		});
	}

	static fromFormGroup(fg: UntypedFormGroup): CallingTreeAdmins {
		return Object.assign(Object.create(CallingTreeAdmins.prototype), {
			rootUserId: fg.get('root').value,
			managerUserId: fg.get('manager').value,
			superCoordinators: CallingTreeSuperCoordinator.fromFormArray(
				fg.get('superCoordinators') as UntypedFormArray
			),
		});
	}
}
